import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import AssetCard from "../../assets/components/AssetCard";
import { useSourceAssets } from "../api/sourceAssets";

export const SourceAssetsTab = ({ source }) => {
  const { assets, loading, error } = useSourceAssets(source.id);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ py: 4 }}>
        <Typography color="error">
          Error loading assets: {error.message}
        </Typography>
      </Box>
    );
  }

  if (!assets || assets.length === 0) {
    return (
      <Box sx={{ py: 4 }}>
        <Typography variant="body1" color="textSecondary">
          No assets found for this source.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ pt: 3 }}>
      <Grid container spacing={2}>
        {assets.map((asset) => (
          <AssetCard key={asset.id} asset={asset} />
        ))}
      </Grid>
    </Box>
  );
};
